module.exports = __webpack_public_path__ + "static/profil-152_optimized-1b8c1f9267db9c5b9b7861bf156fac23.jpg";